import CodeMirror from 'codemirror';


export function matchModel(stream: CodeMirror.StringStream) {
  if (stream.match(/^([A-Za-z_]+[A-Za-z_\d]*(\.[A-Za-z_]+[A-Za-z_\d]*)+)\(/, false)) {
    const matched = stream.match(/^([A-Za-z_]+[A-Za-z_\d]*(\.[A-Za-z_]+[A-Za-z_\d]*)+)/);
    // console.log(matched);
    const model = matched[1];
    // stream.backUp(model.length);
    return `model model:${model}`;
  }
}

export function matchModelPath(stream: CodeMirror.StringStream) {
  // 当前被匹配字符串之前的字符串
  const inputBeforeStart = stream.string.slice(0, stream.column());
  // 判断前面是否为 model
  const isPreviousModel = inputBeforeStart.match(/([A-Za-z_]+[A-Za-z_\d]*(\.[A-Za-z_]+[A-Za-z_\d]*)+)\(\s*$/);
  if (isPreviousModel && stream.match(/^([A-Za-z_]+[A-Za-z_\d]*(\[\])?(\.[A-Za-z_]+[A-Za-z_\d]*(\[\])?)*)\.?\s*\)/, false)) {
    const matched = stream.match(/^([A-Za-z_]+[A-Za-z_\d]*(\[\])?(\.[A-Za-z_]+[A-Za-z_\d]*(\[\])?)*)/);
    const path = matched[1];
    return `model-path path:${path}`;
  }
}
